import React, { useState } from 'react';
import { ContactForm } from './ContactForm';
import './ContactForm.css';
import Meta from './Meta'; 
import sksImage from './assets/sks.jpg';

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalStyle = {
  position: 'relative',
  backgroundColor: '#fff',
  borderRadius: '8px',
  padding: '30px 40px 40px',
  maxWidth: '600px',
  width: '90%',
  boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
};

export default function ProektirovanieSksFundamentNadezhnoyInfrastrukturyVashegoBiznesa() {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);
  return (
 <React.Fragment>
      <Meta
        title="Проектирование СКС под ключ в Москве и Московской области"
        description="Профессиональное проектирование структурированных кабельных систем (СКС) для офисов и ЦОД. Гарантия соблюдения стандартов, оптимизация бюджета."
      />

      <div
        style={{
          fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
          maxWidth: '900px',
          margin: '0 auto',
          padding: '40px 20px',
          lineHeight: 1.6,
          backgroundColor: '#f9f9f9',
          color: '#333',
        }}
      >
        <h1
          style={{
            textAlign: 'center',
            marginBottom: '30px',
            color: '#2c3e50',
          }}
        >
          Проектирование СКС: Фундамент надежной и эффективной IT-инфраструктуры вашего бизнеса
        </h1>

        <section>
            <p style={{ float: 'right', maxWidth: '40%', marginLeft: '20px', marginBottom: '10px' }}>
                 <img src={sksImage} alt="Sks Illustration" style={{ width: '100%', height: 'auto' }} />
            </p>
          <p>
           Задумывались ли вы, что объединяет скоростной интернет, стабильную работу телефонии, безопасную передачу данных между отделами и бесперебойную работу видеонаблюдения? Всё это держится на «кровеносной системе» любого современного офиса, производства или центра обработки данных — <strong>структурированной кабельной системе (СКС)</strong>. Неправильное проектирование СКС на этапе строительства или ремонта ведет к постоянным сбоям, потерям времени и огромным затратам на переделку. В этой статье мы расскажем, почему <strong>профессиональное проектирование структурированных кабельных систем</strong> — это не статья расходов, а стратегическая инвестиция в бесперебойную работу и масштабируемость вашего бизнеса.</p>
        </section>

        <section>
          <h2 style={{
            textAlign: 'center',
            marginBottom: '30px',
            color: '#2c3e50',
          }}>Что такое СКС и почему ее проектирование нельзя доверять «наугад»?</h2>
          <p><strong>Структурированная кабельная система (СКС)</strong> — это универсальная физическая основа для передачи всех видов информации: данных, голоса, видео. Это комплекс кабелей, разъемов, коммутационных панелей и вспомогательного оборудования, организованных по единым стандартам (в основном, международному ISO/IEC 11801).</p>
          <p>Почему проектирование — ключевой этап?</p>
          <ul>
            <li><strong>Экономия бюджета:</strong> Грамотный проект СКС исключает перерасход кабеля, ненужное оборудование и, самое главное, дорогостоящие исправления после монтажа.</li>
            <li><strong>Масштабируемость:</strong> Правильно спроектированная система позволяет добавлять новые рабочие места, серверы или IP-камеры быстро и без разрушительных работ.</li>
            <li><strong>Надежность:</strong> Проект учитывает резервирование, правильную прокладку трасс (вдали от источников помех), что минимизирует простои.</li>
            <li><strong>Поддержка будущих технологий:</strong> Хороший проект закладывает основу для перехода на скорости 10 Гбит/с и выше, работы с PoE (питание для телефонов, камер, точек доступа) без проблем.</li>
            </ul>
          <h2 style={{
            textAlign: 'center',
            marginBottom: '30px',
            color: '#2c3e50',
          }}>Критические ошибки при проектировании СКС, которые будут стоить вам денег</h2>
          <ul>
            <li><strong>Отсутствие аудита и ТЗ:</strong> Проект «на глазок» без технического задания (ТЗ), учитывающего все потребности отделов (ИТ, безопасность, АТС), обречен на неудачу.</li>
            <li><strong>Игнорирование стандартов:</strong> Несоблюдение стандартов ISO/IEC, TIA/EIA ведет к проблемам с совместимостью оборудования и отказом в гарантии от производителей.</li>
            <li><strong>Неучет перспективы:</strong> Экономия на категории кабеля (Cat5e вместо Cat6A) или количестве розеток на рабочем месте ограничит бизнес через 1-2 года.</li>
            <li><strong>Пренебрежение документированием:</strong> Отсутствие схем, паспорта проекта и этикеток на оборудовании превращает последующее обслуживание в «квест» для ваших IT-специалистов.</li>
            </ul>
            
            <h2 style={{
            textAlign: 'center',
            marginBottom: '30px',
            color: '#2c3e50',
          }}>Наш подход к проектированию СКС: Системность, которая дает результат</h2>
          <p>Мы не просто рисуем схемы. Мы создаем технически и экономически обоснованный проект, который станет четким руководством к действию для монтажников и гарантией для вас.</p>
          <h3 style={{
            textAlign: 'center',
            marginBottom: '30px',
            color: '#2c3e50',
          }}>Этапы нашего проектирования:</h3>
          <ul>
            <li><strong>Выездная консультация и обследование объекта:</strong> Анализ архитектурных планов, оценка потребностей заказчика, определение мест размещения активного сетевого оборудования, серверных, кросс-комнат.</li>
            <li><strong>Разработка Технического Задания (ТЗ):</strong> Фиксация всех требований, согласование бюджетов и сроков. Это основа будущего проекта.</li>
            <li><strong>Разработка проектной документации</strong>, включающей:</li>
                   <ul>
                    <li>Структурную схему СКС.</li>
                    <li>Планы размещения кабельных трасс (лотков, труб, стояков).</li>
                    <li>Схемы размещения розеток и телекоммуникационных разъемов.</li>
                    <li>Схемы заземления и электропитания для активного оборудования.</li>
                    <li>Спецификацию на все материалы и оборудование (кабель, патч-панели, розетки, шкафы) с конкретными брендами и моделями.</li>
                    <li>Смету на материалы и работы.</li>
                    
                    </ul>
            <li><strong>Согласование проекта</strong> с заказчиком и, при необходимости, с генподрядчиком или архитектором.</li>
            <li><strong>Авторский надзор</strong> (опционально): Контроль за выполнением монтажных работ в соответствии с проектом для 100% соответствия результата.</li>
            
            </ul>
            <h2 style={{
            textAlign: 'center',
            marginBottom: '30px',
            color: '#2c3e50',
          }}>Начните с правильного проекта — сохраните нервы, время и бюджет</h2>
          <p>Проектирование структурированных кабельных систем — это работа для профессионалов, которая окупается стабильностью, безопасностью и готовностью вашей инфраструктуры к вызовам завтрашнего дня.</p>
          <p>Не закладывайте проблемы в основу своего бизнеса. Доверьте создание цифрового фундамента нам.</p>
          
          
        </section>


             <div style={{ textAlign: 'center', marginTop: '40px' }}>
                    <button
                      onClick={openModal}
                      style={{
                        backgroundColor: '#2980b9',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '6px',
                        padding: '14px 30px',
                        fontSize: '1.1em',
                        fontWeight: '600',
                        cursor: 'pointer',
                        transition: 'background-color 0.3s',
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#2471a3')}
                      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#2980b9')}
                    >
                      Оставить заявку
                    </button>
                  </div>
            
                  {modalOpen && (
                    <div style={overlayStyle} onClick={closeModal} role="dialog" aria-modal="true" aria-labelledby="modal-title">
                      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
                        <div
                          style={{
                            position: 'absolute',
                            top: 12,
                            right: 12,
                            width: 32,
                            height: 32,
                            cursor: 'pointer',
                            borderRadius: '50%',
                            backgroundColor: '#f0f0f0',
                            color: '#333',
                            fontSize: 24,
                            fontWeight: 'bold',
                            lineHeight: '32px',
                            textAlign: 'center',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                            transition: 'background-color 0.3s, color 0.3s, box-shadow 0.3s',
                            userSelect: 'none',
                          }}
                          onClick={closeModal}
                          aria-label="Закрыть"
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#e0e0e0';
                            e.currentTarget.style.color = '#000';
                            e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#f0f0f0';
                            e.currentTarget.style.color = '#333';
                            e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
                          }}
                          onMouseDown={(e) => {
                            e.currentTarget.style.backgroundColor = '#d0d0d0';
                            e.currentTarget.style.boxShadow = 'inset 0 2px 4px rgba(0,0,0,0.2)';
                          }}
                          onMouseUp={(e) => {
                            e.currentTarget.style.backgroundColor = '#e0e0e0';
                            e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
                          }}
                        >
                          ×
                        </div>
                        <ContactForm />
                      </div>
                    </div>
      )}
      </div>

    </React.Fragment>
  );
}